import { useEffect, useRef } from "react";
import { useLogin } from "@/features/authentication";

const usePostLogin = () => {
  const { onSuccessLogin } = useLogin();
  const onSuccessLoginRef = useRef(onSuccessLogin);
  onSuccessLoginRef.current = onSuccessLogin;

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === "login-success") {
        onSuccessLoginRef.current();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
};

export default usePostLogin;
